/**
 * Форматирование денег биллинга платформы.
 *
 * С 2026-08-21 тарифы платформы в тенге (решение владельца — вся цепочка
 * лендинг→суперадминка в KZT): `plans.currency = 'KZT'`, новые
 * subscription_invoices копируют валюту плана. Поля RPC `mrr_kzt` и т.п.
 * сохранили legacy-имена (контракт 00103), но значения — в валюте планов.
 *
 * ⚠️ НЕ использовать для выручки кафе (заказы гостей) — она в тенге.
 */
export function fmtMoney(amount: number, currency?: string | null): string {
  if (currency === "USD") return `$${amount.toLocaleString("en-US")}`;
  if (currency === "EUR") return `€${amount.toLocaleString("ru-RU")}`;
  const sym = currency === "RUB" ? "₽" : "₸";
  return `${amount.toLocaleString("ru-RU")} ${sym}`;
}

/** Валюта планов платформы (после возврата на тенге 2026-08-21). */
export const PLATFORM_CURRENCY = "KZT";
